import type { APIResponse } from '~~/models/serviceModels/APIResponse';
import type { Player, Turn, Game } from '../../models';

export function GetNameList(players: Player[]): string {
    if (players == undefined || players.length == 0)
        return "";

    return players.map(p => p.name).join(', ');
}
export function GetRollCount(turns: Turn[], rollNumber: number): number {

    if (turns == undefined || turns.length == 0)
        return 0;
    return turns.filter(t => t.roll == rollNumber).length;
}
export function GetLastRoll(turns: Turn[]): number {
    if (turns == undefined || turns.length == 0)
        return 0;

    var lastTurn = turns.slice().reverse()[0];
    if(lastTurn == null)
        return 0;

    return lastTurn.roll
}
export function GetCurrentRollPlayer(turns: Turn[], players: Player[]): string {
    if (turns == undefined || turns.length == 0)
        return '';

    const lastTurn = turns.slice().reverse()[0];
    if (lastTurn == undefined)
        return '';
    const playerID = lastTurn.playerID;
    const player = players.find(p => p.id == playerID);
    if (player == undefined)
        return '';
    return player.name;
}

// import { createClient } from '@supabase/supabase-js'
// const config = useRuntimeConfig()
// const supabase = createClient(config.public.supabaseUrl as string, config.public.supabaseAnonKey as string)


// export async function getInstruments() {
//     const { data } = await supabase.from('instruments').select()
//     //instruments.value = data
//   }

export async function saveGame(game: Game) : Promise<APIResponse> {
    return await $fetch('/api/game', {
        method: 'POST',
        body: game,
    });
}

export async function udpateGame(game: Game) : Promise<APIResponse> {
    return await $fetch('/api/game', {
        method: 'POST',
        body: game,
    });
}

export async function getGame(id: string) : Promise<APIResponse> {
    return await $fetch('/api/game/' + id, {
        method: 'GET',
    });
}

export async function getGames(userID: string) : Promise<APIResponse> {
    return await $fetch('/api/games/' + userID, {
        method: 'GET',
    });
}

export async function saveTurns(game: Game) : Promise<APIResponse> {
    return await $fetch('/api/game/turns', {
        method: 'POST',
        body: game,
    });
}


export async function saveSettings(game: Game) : Promise<APIResponse> {
    return await $fetch('/api/game/settings', {
        method: 'POST',
        body: game,
    });
}
// export async function  getGameHistory(userID:string) : Promise<APIResponse> {
//     return await $fetch('/api/game/history', {
//         method: 'POST',
//         body: {userID: userID},
//     });
// }

export async function deleteGame(id: string) : Promise<APIResponse> {
    return await $fetch('/api/game', {
        method: 'DELETE',
        body: id,
    });
}